<template>
    <section class="new-cadence-information-welcome d-flex flex-row justify-content-center py-3">
        <p> Szanowni Państwo, witamy w kadencji <b>2024-2029</b></p>
    </section>
</template>
<script charset="utf-8">
    export default {
        name: "WelcomeInNewCadence",
        methods: {
        }
    }
</script>
<style lang="scss">
    .new-cadence-information-welcome {
        background: #b2f7d5;
        //margin-top: 5px;
        font-size: 14px;
        text-align: center;
    }
</style>